import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import CreateCheckForm from "../../../components/InstrallationWorkForm/CheckReceive/CreateCheckForm";
import InFormInstallAcceptService from "../../../services/informinstallaccept.service";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import InformInstallJobsService from "../../../services/informinstalljob.service";

export default function CreateCheck() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const commonNavigate = (Accept_Id) => {
    navigate("/installation_work/check", {
      state: { name: "data", searchValue: `${Accept_Id}` }
    });
    navigate(0);
  };

  const handleSubmit = (dataCallback) => {
    dataCallback.forEach((item) => {
      let Accept_Id = null;
      const serviceRequest =
        InFormInstallAcceptService.createInFormInstallAccept({ array: [item] });
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: serviceRequest,
        callback: ({ generatedMaps }) => {
          const informDocStatus =
            generatedMaps?.[0]?.inst_reject === true ? "RECEIVED" : "REJECT";
          Accept_Id = generatedMaps[0].Id;

          addEditServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: InformInstallJobsService.editInformInstallJobs(
              item?.inform_install_job_id,
              { Inform_Install_Status: informDocStatus }
            ),
            navigated: (navi) => navi && commonNavigate(Accept_Id)
          });
        }
      });
    });
  };

  return <CreateCheckForm onSubmitCallback={handleSubmit} />;
}
